export default __webpack_public_path__ + "static/media/hostelapp.b99c5206.png";